module.exports = __webpack_public_path__ + "static/img/SC8.0a94ddb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC8.jpg
// module id = h8lh
// module chunks = 0